export default __webpack_public_path__ + "static/media/app.ee408af6.png";